<template>
    <div class="row">
        <div class="col-md-6 col-xl-3">
            <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                    <div>
                        <i class="fa fa-2x fa-suitcase text-muted"></i>
                    </div>
                    <dl class="ms-3 text-end mb-0">
                        <dt class="h3 fw-extrabold mb-0">
                            {{ managers }}
                        </dt>
                        <dd class="fs-sm fw-medium text-muted mb-0">
                            Managers
                        </dd>
                    </dl>
                </div>
            </a>
        </div>
        <div class="col-md-6 col-xl-3">
            <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                    <div>
                        <i class="far fa-2x fa-solid fa-user-tie text-muted"></i>
                    </div>
                    <dl class="ms-3 text-end mb-0">
                        <dt class="h3 fw-extrabold mb-0">
                            {{ admins }}
                        </dt>
                        <dd class="fs-sm fw-medium text-muted mb-0">
                            Admins
                        </dd>
                    </dl>
                </div>
            </a>
        </div>
        <div class="col-md-6 col-xl-3">
            <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                    <div>
                        <i class="fa fa-2x fa-solid fa-motorcycle text-muted"></i>
                    </div>
                    <dl class="ms-3 text-end mb-0">
                        <dt class="h3 fw-extrabold mb-0">
                            {{ couriers }}
                        </dt>
                        <dd class="fs-sm fw-medium text-muted mb-0">
                            Courier
                        </dd>
                    </dl>
                </div>
            </a>
        </div>
        <div class="col-md-6 col-xl-3">
            <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                <div class="block-content block-content-full d-flex align-items-center justify-content-between">
                    <div>
                        <i class="fa fa-2x fa-users text-muted"></i>
                    </div>
                    <div class="ms-3 text-end mb-0">
                        <p class="h3 fw-extrabold mb-0">
                            {{ sellers }}
                        </p>
                        <p class="fs-sm fw-medium text-muted mb-0">
                            Sellers
                        </p>
                    </div>
                </div>
            </a>
        </div>
    </div>
    <meta name="csrf-token" :content="csrfToken" />

    <!-- Filter inputs that will be toggled -->
    <div id="filter-area" class="collapse mb-4">
        <div class="row">
            <!-- Client Filter -->
            <div class="col-md-3">
                <div class="form-group">
                    <label class="form-label" style="font-size: 0.9em;"
                        for="example-select">{{ $t('input_client') }}</label>
                    <div>
                        <select class="selectpicker show-menu-arrow" data-select-all-headers="true" data-size='5'
                            data-dropup-auto="false" data-selected-text-format="count > 2" multiple
                            data-actions-box="true" data-live-search="true" id="ClientFilter" name="ClientFilter">
                            <option v-for="role in roles" :key="role.id" :value="role.id">
                                {{ role . role_title }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Status Filter -->
            <div class="col-md-3">
                <div class="form-group">
                    <label class="form-label" style="font-size: 0.9em;"
                        for="example-select">{{ $t('input_shipment_status') }}</label>
                    <div>
                        <select class="selectpicker show-menu-arrow" data-select-all-headers="true" data-size='5'
                            data-dropup-auto="false" data-selected-text-format="count > 2" multiple
                            data-actions-box="true" data-live-search="true" id="ShipmentStatusFilter"
                            name="ShipmentStatusFilter">
                            <option v-for="user in users" :key="user._id" :value="user._id">
                                {{ user . fisrt_name }} {{ user . last_name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- Price Range Filter -->

            <!-- Filter Buttons -->
            <div class="col-md-12" style="text-align: right;">
                <button class="btn btn-sm btn-outline-primary me-2" id="applyFilters">Apply Filters</button>
            </div>
        </div>
    </div>

    <!-- Staff List Table -->
    <div class="block-rounded block" id="usersContainer">
        <div class="block-header block-header-default">
            <h3 class="block-title">
                {{ $t('title_result') }} <span>({{ totalUsers }})</span>
            </h3>
        </div>

        <div class="block-content">
            <div class="table-responsive">
                <!-- Show Actual Table when data is loaded -->
                <table class="table-hover table table-sm fs-sm text-center">
                    <thead>
                        <tr>
                            <th>{{ $t('table_name') }}</th>
                            <th>{{ $t('table_mobile_number') }}</th>
                            <th>{{ $t('table_role') }}</th>
                            <th>{{ $t('table_plan_title') }}</th>
                            <th>{{ $t('table_courier_rate') }}</th>
                            <th>{{ $t('table_status') }}</th>
                            <th>{{ $t('table_joined_at') }}</th>
                            <th></th>
                        </tr>
                        <tr>
                            <th>
                                <input type="text" class="form-control form-control-sm fs-sm" v-model="filters.name"
                                    @change="fetchData" id="name_search" name="name_search"
                                    placeholder="Search Name" />
                            </th>
                            <th>
                                <input type="text" class="form-control form-control-sm fs-sm" v-model="filters.number"
                                    @change="fetchData"
                                    id="phone_number_search" name="phone_number_search" placeholder="Search Number" />
                            </th>
                            <th>
                                <select class="form-control form-control-sm fs-sm" v-model="filters.role"
                                    @change="fetchData" id="role_filter" name="role_filter" placeholder="Filter Role">
                                    <option value="" disabled selected>Select Role</option>
                                    <option v-for="role in user_roles" :key="role._id" :value="role._id">
                                        {{ role . role_title }}</option>
                                </select>
                            </th>
                            <th>
                                <select class="form-control form-control-sm fs-sm" v-model="filters.plan"
                                    @change="fetchData" id="plan_filter" name="plan_filter" placeholder="Filter Plan">
                                    <option value="" disabled selected>Select Plan</option>
                                    <option v-for="plan in price_plans" :key="plan._id"
                                        :value="plan._id">{{ plan . title }}</option>
                                </select>
                                
                            </th>
                            <th>
                                <input type="number" class="form-control form-control-sm fs-sm" v-model="filters.courier_rate"
                                    @change="fetchData" id="courier_rate_search" name="courier_rate_search"
                                    placeholder="Search Courier Rate" />
                            </th>
                            <th>
                                <select class="form-control form-control-sm fs-sm" placeholder="Filter Status" v-model="filters.status"
                                    @change="fetchData" id="status_filter" name="status_filter">
                                    <option value="">Select Status</option>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>
                            </th>
                            <th>
                                <input type="date" class="form-control form-control-sm fs-sm" v-model="filters.joined_at"
                                    @change="fetchData" id="joined_at_search" name="joined_at_search"
                                    placeholder="Filter Join Date" />
                            </th>
                            <th>
                                <button type="button" class="btn btn-secondary btn-sm" @click="clearFilters" title="Clear Filters">
                                    <i class="fa fa-solid fa-trash"></i>
                                </button>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="staff in staffData" :key="staff._id">
                            <td>
                                <div class="d-flex align-items-center">
                                    <img :alt="staff.avatar" :src="staff.avatar" class="rounded-circle me-2"
                                        style="width: 32px;" />
                                    <a :href="`/profile/${staff._id}`">{{ staff . first_name }}
                                        {{ staff . last_name }}</a>
                                </div>
                            </td>
                            <td>{{ staff . phone_number }}</td>
                            <td>{{ staff . role . role_title }}</td>
                            <td>{{ staff.plan?.title || 'N/A' }}</td>
                            <td>{{ staff . courier_rate }} EGP</td>
                            <td>
                                <span class="fs-xs fw-semibold d-inline-block py-1 px-3 rounded-pill"
                                    :class="staff.is_active ? 'bg-success-light text-success' : 'bg-danger-light text-danger'"
                                    style="cursor: pointer;">
                                    {{ staff . is_active ? 'Active' : 'Inactive' }}
                                </span>
                            </td>
                            <td>{{ new Date(staff . created_at) . toLocaleDateString() }}</td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-light btn-sm dropdown-toggle" type="button"
                                        data-bs-toggle="dropdown">
                                        <i class="bi bi-three-dots"></i>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li v-for="action in getActions(staff)" :key="action.label">
                                            <a class="dropdown-item btn-sm"
                                                @click="action.command(staff)">{{ action . label }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
    <!-- Pagination Component -->
    <Pagination :totalPages="totalPages" :currentPage="currentPage" @page-change="fetchData" />

    <!-- Reset Password Modal -->
    <div class="modal fade" id="editProfileModal" tabindex="-1" role="dialog"
        aria-labelledby="editProfileModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="block-rounded block-$tparent mb-0 block">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Edit User Data</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal"
                                aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <form id="editProfileForm">
                        <input type="hidden" id="user_id_update" name="user_id" readonly>
                        <div class="block-content fs-sm">
                            <div class="mb-3">
                                <label class="form-label" for="first_name_input">Name<span
                                        style="color: red;">*</span></label>
                                <input required="" type="text" v-model="first_name_input" class="form-control"
                                    id="first_name_input" name="first_name_input">
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="last_name_input">Name<span
                                        style="color: red;">*</span></label>
                                <input required="" type="text" v-model="last_name_input" class="form-control"
                                    id="last_name_input" name="last_name_input">
                            </div>
                            <div class="mb-3">
                                <label for="">Role</label>
                                <select class="form-select" v-model="roleSelect" name="roleSelect">
                                    <option v-for="role in user_roles" :key="role._id" :value="role._id">
                                        {{ role . role_title }}</option>
                                </select>
                            </div>

                            <div class="mb-3">
                                <label for="">Price Plan</label>
                                <select class="form-select" v-model="pricePlanSelect" name="pricePlanSelect">
                                    <option v-for="plan in price_plans" :key="plan._id"
                                        :value="plan._id">{{ plan . title }}</option>
                                </select>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="courier_rate_input">Courier Rate<span
                                        style="color: red;">*</span></label>
                                <input type="number" class="form-control" v-model="courier_rate_input"
                                    id="courier_rate_input" name="courier_rate_input" placeholder="0"
                                    @input="courier_rate_input = courier_rate_input || 0">
                            </div>
                        </div>

                        <div class="block-content block-content-full bg-body text-end">
                            <button type="button" class="btn btn-sm btn-secondary me-1"
                                data-bs-dismiss="modal">Cancel</button>
                            <button class="btn btn-sm btn-primary" @click="updateProfile($event)">Update</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <!-- Reset Password Modal -->
    <div class="modal fade" id="resetPasswordModal" tabindex="-1" role="dialog"
        aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="block-rounded block-$tparent mb-0 block">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Reset Password</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal"
                                aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <form id="resetPasswordForm">
                        <input type="hidden" id="user_id_reset" name="user_id" readonly>
                        <div class="block-content fs-sm">
                            <div class="mb-3">
                                <div class="input-group">
                                    <input disabled type="text" id="generated_password" class="form-control"
                                        readonly placeholder="Generated password">
                                    <button type="button" class="btn btn-primary" id="generatePasswordBtn">
                                        <i class="fa-solid fa-rotate-right"></i>
                                    </button>
                                    <button type="button" class="btn btn-secondary" id="copyPasswordBtn"><i
                                            class="fa-regular fa-copy"></i></button>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="new_password">New Password</label>
                                <input type="password" class="form-control" id="new_password" name="password"
                                    placeholder="Enter new password" required>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" for="confirm_password">Confirm Password</label>
                                <input type="password" class="form-control" id="confirm_password"
                                    name="password_confirmation" placeholder="Confirm new password" required>
                            </div>
                        </div>
                        <div class="block-content block-content-full bg-body text-end">
                            <button type="button" class="btn btn-sm btn-secondary me-1"
                                data-bs-dismiss="modal">Cancel</button>
                            <button type="submit" class="btn btn-sm btn-primary">Reset Password</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        ref
    } from "vue";
    import Menu from "primevue/menu";
    import Button from "primevue/button";
    import axios from "axios";
    import Skeleton from 'primevue/skeleton';
    import Pagination from "../../common/Pagination.vue";
    export default {
        components: {
            Pagination,
            Menu,
            Button,
            Skeleton,
        },
        data() {
            return {
                isLoading: true,
                skeletonColumns: [1, 2, 3, 4, 5, 6, 7], // Define column count for skeleton
                csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                searchTerm: '',
                filters: {
                    name: '',
                    role: '', // Initially, no role selected
                    partner_id: '',
                    number: '',
                    plan: '',
                    courier_rate: '',
                    status: '',
                    joined_at: '',
                },
                perPage: 20,
                staffData: [],
                actionMenus: {}, // Dynamic refs for dropdowns
                totalUsers: 0,
                currentPage: 1,
                totalPages: 1, // Example total pages
                lastPage: 1,
                paginationFirstText: 'First',
                paginationLastText: 'Last',
                roles: [],
                users: [],
                minCredit: 0,
                maxCredit: 100,
                minDebt: 0,
                maxDebt: 100,
                minBalance: 0,
                maxBalance: 100,
                activeDropdown: null, // Track which user's dropdown is open
                selectedUserId: null,
                first_name_input: '',
                last_name_input: '',
                roleSelect: '',
                pricePlanSelect: '',
                courier_rate_input: null,
                price_plans: [],
                user_roles: [],
                managers: 0,
                admins: 0,
                couriers: 0,
                sellers: 0
            };
        },
        computed: {
            paginationRange() {
                const range = [];
                const start = Math.max(1, this.currentPage - 3);
                const end = Math.min(this.lastPage, this.currentPage + 3);

                for (let i = start; i <= end; i++) {
                    range.push(i);
                }

                return range;
            }
        },
        methods: {
            fetchData(page = 1) {
                this.currentPage = page; // Update currentPage
                const params = {
                    search: this.searchTerm,
                    page: this.currentPage,
                    perPage: this.perPage,
                    name: this.filters.name,
                    role: this.filters.role,
                    partner_id: this.filters.partner_id,
                    number: this.filters.number,
                    plan: this.filters.plan,
                    courier_rate: this.filters.courier_rate,
                    status: this.filters.status,
                    joined_at: this.filters.joined_at,
                };
                axios.get(`/partner-users/get-partner-users`, {params})
                    .then(response => {
                        One.layout('header_loader_off');
                        this.staffData = response.data.data;
                        this.totalUsers = response.data.total;
                        this.lastPage = response.data.last_page;
                        this.perPage = response.data.per_page;
                        this.totalPages = Math.ceil(response.data.total / response.data
                            .per_page); // Calculate total pages
                    })
                    .catch(error => {
                        One.layout('header_loader_off');
                        console.error('Error fetching staff:', error);
                    }).finally(() => {
                        this.isLoading = false;
                    });
            },
            clearFilters() {
                this.filters = {
                    name: '',
                    role: '',
                    partner_id: '',
                    number: '',
                    plan_title: '',
                    courier_rate: '',
                    status: '',
                    joined_at: '',
                };
                this.fetchData(); // Refetch data with cleared filters
            },
            toggleMenu(event, userId) {
                if (this.actionMenus[userId]) {
                    this.actionMenus[userId].toggle(event);
                }
            },
            setActionMenuRef(el, userId) {
                if (el) {
                    this.actionMenus[userId] = el;
                }
            },
            getActions(user) {
                return [{
                        label: "Edit Profile",
                        icon: "pi pi-user-edit",
                        command: () => this.showUpdateProfileModal(user._id),
                    },
                    {
                        label: "Reset Password",
                        icon: "pi pi-refresh",
                        command: () => this.resetPassword(user._id),
                    },
                    {
                        label: user.is_active ? "Deactivate" : "Activate",
                        icon: user.is_active ? "pi pi-power-off" : "pi pi-check",
                        command: () => this.toggleActivation(user),
                    },
                ];
            },
            changePage(page) {
                if (page !== this.currentPage) {
                    this.$emit("page-change", page); // Notify parent to update currentPage
                }
            },
            updatePerPage(perPage) {
                this.perPage = perPage;
                this.currentPage = 1; // Reset to first page
                this.fetchData();
            },
            countRoles() {
                axios.get(`/partner-users/get-users-count`)
                    .then(response => {
                        this.managers = response.data.managers;
                        this.admins = response.data.admins;
                        this.couriers = response.data.couriers;
                        this.sellers = response.data.sellers;
                    })
                    .catch(error => {
                        console.error('Error fetching roles count:', error);
                    });
            },
            fetchRoles() {
                axios.get(`/roles/get-roles`)
                    .then(response => {
                        this.user_roles = response.data;
                    })
                    .catch(error => {
                        console.error('Error fetching roles:', error);
                    });
            },
            fetchPricePlans() {
                axios.get(`/price-plans/get-all-plans`).then(response => {
                        this.price_plans = response.data.plans;
                    })
                    .catch(error => {
                        console.error('Error fetching price plans:', error);
                    });
            },
            toggleSettlement(user) {
                if (!user.is_settled) {
                    axios.post('/settle-transaction', {
                            transaction_id: user._id
                        })
                        .then(() => {
                            user.is_settled = true;
                        })
                        .catch(error => {
                            console.error('Error settling transaction:', error);
                        });
                }
            },
            showUpdateProfileModal(userId) {
                const user = this.staffData.find(u => u._id === userId);
                if (!user) {
                    console.error("User not found:", userId);
                    return;
                }

                this.selectedUserId = userId;
                this.first_name_input = user.first_name || '';
                this.last_name_input = user.last_name || '';
                this.courier_rate_input = user.courier_rate || null;
                this.roleSelect = user.role_id || '';
                this.pricePlanSelect = user.plan_id || '';

                $('#editProfileModal').modal('show');
            },
            updateProfile(event) {
                if (event) event.preventDefault(); // Prevent form submission
                One.layout('header_loader_on');
                const formData = new FormData();
                formData.append('user_id', this.selectedUserId);
                formData.append('first_name_input', this.first_name_input);
                formData.append('last_name_input', this.last_name_input);
                formData.append('roleSelect', this.roleSelect);
                formData.append('pricePlanSelect', this.pricePlanSelect);
                formData.append('courier_rate_input', this.courier_rate_input);

                axios.post('/partner-users/update', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'X-CSRF-TOKEN': this.csrfToken
                        }
                    })
                    .then(() => {
                        $('#editProfileModal').modal('hide');
                        this.fetchData();
                    })
                    .catch(error => {
                        One.layout('header_loader_off');
                        console.error('Error updating profile:', error);
                    }).finally(() => {
                        countRoles();
                    });
            },
            resetPassword(userId) {
                document.getElementById('user_id_reset').value = userId;
                $('#resetPasswordModal').modal('show');
            },
            toggleActivation(user) {
                const action = user.is_active ? 'deactivate' : 'activate';
                axios.post(`/users/${action}-user`, {
                        user_id: user._id
                    })
                    .then(() => {
                        user.is_active = !user.is_active;
                    })
                    .catch(error => {
                        console.error('Error changing activation:', error);
                    });
            },
            toggleDropdown(userId) {
                this.activeDropdown = this.activeDropdown === userId ? null : userId;
            },
            closeDropdown() {
                this.activeDropdown = null;
            },
            activateUser(user) {
                axios.post(`users/activate`, {
                        user: user._id
                    })
                    .then(() => {
                        user.is_active = true;
                        this.activeDropdown = null; // Close the dropdown
                    })
                    .catch(error => {
                        console.error('Error activating user:', error);
                    });
            },
            deleteUser(user) {
                axios.post(`/delete-user/${user._id}`)
                    .then(() => {
                        this.staffData = this.staffData.filter(u => u._id !== user._id);
                        this.activeDropdown = null; // Close the dropdown
                    })
                    .catch(error => {
                        console.error('Error deleting user:', error);
                    });
            },
            updateCourierRate(user) {
                // Call API to update the rate
                axios.post('/update-courier-rate', {
                        user_id: user.id,
                        courier_rate: user.courier_rate
                    })
                    .then(response => {
                        console.log('Updated successfully', response.data);
                    })
                    .catch(error => {
                        console.error('Error updating rate', error);
                    });
            },
            changePage(page) {
                this.currentPage = page;
                this.fetchData();
            }
        },
        mounted() {
            this.fetchData();
            this.countRoles();
            this.fetchRoles();
            this.fetchPricePlans();
            document.addEventListener('click', this.closeDropdown);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.closeDropdown);
        }
    };
</script>

<style scoped>
    /* Add your styles here */
    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
    }

    .dropdown-menu.show {
        display: block;
    }

    .dropdown-item {
        padding: 10px;
        cursor: pointer;
    }

    .dropdown-item:hover {
        background-color: #f8f9fa;
    }
</style>
